module.exports = __webpack_public_path__ + "static/media/matt-right.0354479d.PNG";